import React from 'react';

import {
  DrawerContentType,
  useWorkspaceDrawerContext,
} from '../WorkspaceDrawerContextProvider';
import {LinePlotSectionSettings} from './LinePlotSectionSettings';
import {SectionSettingsContextProvider} from './SectionSettingsContextProvider';

// This will be deprecated soon when media section settings are added, because
// there will be more than one option for the section settings.
export const SectionSettingsWithoutMenuItems = ({
  displayedContentType,
}: {
  displayedContentType: DrawerContentType;
}) => {
  const {targetSectionRef} = useWorkspaceDrawerContext();
  if (targetSectionRef == null) {
    return null;
  }

  return (
    <SectionSettingsContextProvider sectionRef={targetSectionRef}>
      <LinePlotSectionSettings
        contentHeader={
          <h2 className="text-sm font-semibold leading-[22px] text-moon-500">
            SECTION SETTINGS
          </h2>
        }
        displayedContentType={displayedContentType}
      />
    </SectionSettingsContextProvider>
  );
};
